import { createContext, useContext } from 'react';
import type { RefObject } from 'react';

/**
 * The app shell's scrolling element, published so pages can reach it.
 *
 * Pages inside AppLayout do not scroll themselves — `<main>` does. A page that
 * needs to know the scroll position (pull-to-refresh, #1466) therefore has no
 * way to find it without either walking the DOM or querying for a tag name,
 * both of which break silently the first time the shell changes.
 *
 * The default is a ref holding null, so a page rendered outside the shell
 * degrades to "no scroll container" rather than throwing.
 */
export const ScrollContainerContext = createContext<RefObject<HTMLElement | null>>({
  current: null,
});

export function useScrollContainer(): RefObject<HTMLElement | null> {
  return useContext(ScrollContainerContext);
}
